import { FC } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, ButtonVariants, Modal, useModalControl } from '@frontend/design-system';

interface Props {
  trackingId?: string;
  wistiaVideoId: string;
  buttonVariant?: ButtonVariants;
}

export const VideoPlayer: FC<React.PropsWithChildren<Props>> = ({
  trackingId,
  wistiaVideoId,
  buttonVariant = 'tertiary',
}) => {
  const { t } = useTranslation('phone');
  const videoModalControl = useModalControl();

  return (
    <>
      <Button
        iconName='play'
        variant={buttonVariant}
        size='large'
        {...videoModalControl.triggerProps}
        trackingId={trackingId}
      >
        {t('See it')}
      </Button>
      <Modal {...videoModalControl.modalProps} css={styles.wrapper} minWidth={1120}>
        <Modal.Header
          css={css`
            display: flex;
            flex-direction: column;
            align-items: end;
            padding: 0;
            margin: 0 ${theme.spacing(1)} 0;
            background-color: ${theme.colors.black};
          `}
        >
          <Button
            iconName='x'
            onClick={videoModalControl.closeModal}
            css={css`
              width: 20px;
              height: 20px;
            `}
          />
        </Modal.Header>
        <Modal.Body>
          <iframe
            allowFullScreen
            css={styles.iframe}
            src={`https://fast.wistia.net/embed/iframe/${wistiaVideoId}?wmode=opaque`}
            title={t('Help Video')}
          ></iframe>
        </Modal.Body>
      </Modal>
    </>
  );
};

const styles = {
  wrapper: css`
    padding: 0;
    height: 704px;
    background-color: black;

    > div {
      background-color: ${theme.colors.white};
      overflow: hidden;
      padding: 0;
    }
  `,

  iframe: css`
    border: none;
    height: 100%;
    width: 100%;
  `,
};
